import React, { createContext, useContext, useState } from 'react';

// Shared mobile drawer state — lets the top-bar hamburger (App.js) and the
// off-canvas sidebar drawer (Navbar) talk to each other.
const MobileNavContext = createContext(null);

export function MobileNavProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <MobileNavContext.Provider value={{ drawerOpen, setDrawerOpen }}>
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav() {
  return useContext(MobileNavContext) || { drawerOpen: false, setDrawerOpen: () => {} };
}
